<template>
  <SelectRoot v-model:open="isOpen" :disabled="disabled">
    <SelectTrigger
      v-bind="$attrs"
      class="inline-flex h-[35px] items-center justify-between gap-[5px] rounded border bg-white px-[15px] text-[13px] leading-none text-theme-1 shadow-black/10 outline-none data-[disabled]:pointer-events-none data-[disabled]:bg-theme-placeholder-bg data-[placeholder]:text-theme-non-active"
    >
      <img v-if="icon" :src="icon" class="h-5 w-7 cursor-pointer object-contain" />

      <SelectValue
        v-if="!iconOnly"
        :placeholder="placeholder"
        class="h-full w-full content-center overflow-hidden text-ellipsis whitespace-nowrap text-left"
      >
        {{ selectedOptionLabel }}
      </SelectValue>

      <img
        class="transition-all"
        :class="{ 'rotate-180': isOpen, invert: isArrowColorInverted }"
        :src="ArrowDown.src"
      />
    </SelectTrigger>

    <SelectContent
      position="popper"
      class="z-[100] mt-1 max-h-80 min-w-[8rem] overflow-auto rounded border-1 bg-white will-change-[opacity,transform]"
    >
      <slot></slot>
    </SelectContent>
  </SelectRoot>
</template>

<script setup lang="ts">
import { SelectRoot, SelectValue, SelectTrigger, SelectContent } from "radix-vue";
import { ref } from "vue";
import ArrowDown from "../IAIIcon/icons/ArrowDown.svg";

defineProps({
  placeholder: { type: String, default: "" },
  disabled: { type: Boolean, default: false },
  icon: { type: String, required: false },
  iconOnly: { type: Boolean, default: false },
  selectedOptionLabel: { type: String, required: false },
  isArrowColorInverted: { type: Boolean, default: false },
});

const isOpen = ref(false);
</script>

<style scoped lang="scss"></style>
